module.exports = __webpack_public_path__ + "static/media/get-notified.0bd8b540.svg";